import React from 'react'
import Input from '../../../../../../../../../Components/Input/Input'
import DashboardBatchesStore from '../../../Stores/DashboardBatchesStore'
import { useHistory } from 'react-router-dom'
import Button from '../../../../../../../../../Components/Buttons/Button'
import BatchTimingsStore from '../../../Stores/BatchTimingsStore'

const options = [
  { label: 'Active Batches', value: true },
  { label: 'Completed Batches', value: false },
]

function FilterBox() {
  const history = useHistory()
  const { setFilter, courseId } = DashboardBatchesStore.useContainer()
  const { userType } = BatchTimingsStore.useContainer()

  return (
    <div className='filterBox' style={{ width: '100%' }}>
      <div
        style={{
          flex: 1,
        }}
      >
        {userType === 'teacher' && (
          <Button
            onClick={() => {
              history.push(`/dashboard/teacher/course/${courseId}/batches`)
            }}
            name={'Create Batch'}
            type={'primary'}
            className={'courseButtons'}
          />
        )}
      </div>
      <Input
        type='select'
        defaultValue={options[0]}
        options={options}
        onChange={({ value }) => setFilter(value)}
      />
    </div>
  )
}

export default FilterBox
